import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const MAX_WIDTH = 1200;
const PADDING = 40;
const MAX_FONT_SIZE = 96;
const MIN_FONT_SIZE = 40;

export default function ExpertGuidanceSection() {
  const [fontSize, setFontSize] = useState("96px");
  const containerRef = useRef(null);

  const handleResize = () => {
    if (!containerRef.current) return;

    const newFontSize = Math.max(MIN_FONT_SIZE, MAX_FONT_SIZE * (containerRef.current.offsetWidth / (MAX_WIDTH - PADDING))) + "px";
    setFontSize(newFontSize);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <StyledSection ref={containerRef}>
      <p className="primary-text" style={{ fontSize: fontSize }}>
        Looking for <span className="primary-text-blue">Expert</span>
      </p>
      <div className="secondary-text-wrapper">
        <p className="primary-text primary-text-blue" style={{ fontSize: fontSize }}>
          Guidance?
        </p>
        <p className="secondary-text">Our team of specialists is here to help you safeguard your asset with a tailored risk mitigation strategy</p>
      </div>
    </StyledSection>
  );
}

const StyledSection = styled.section`
  margin-top: 64px;

  .primary-text {
    text-transform: uppercase;
    font-weight: 700;
    margin: 0;
    padding: 0;
    letter-spacing: 2px;
  }

  .primary-text-blue {
    color: #0000ff;
  }

  .secondary-text-wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .secondary-text {
    font-size: 20px;
    line-height: 32px;
    margin: 0;
    padding: 0;
    letter-spacing: 1px;
  }

  @media (max-width: 1013px) {
    .secondary-text-wrapper {
      display: grid;
      gap: 10px;
    }
  }

  @media (max-width: 445px) {
    .secondary-text {
      font-size: 18px;
    }
  }
`;
